/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  CardTitlePrimary,
  CardFooter,
  Input,
} from '@design-system-coopeuch/web';
import Modal from '../../atoms/Modal';
import { stepperAction } from '../../../../application/actions/stepper';
import iconMensajeInfo from '../../../assets/img/icon/TooltTip.svg';
import Checkbox from '../../atoms/CheckBox/Checkbox';
import { Wrapper } from './styles';
import { properties } from '../../../../utils/properties';

const VerificacionTemplate = ({
  activeMenu,
  autorizoFunction,
  setAutorizo,
  valueInputRut,
  mensajeInputRut,
  valueNdeSerie,
  mensajeInputSerie,
  obtenerRutInput,
  obtenerNumeroSerieInput,
}) => {

  const dispatch = useDispatch();
  const [isOpenedModal, setStateModal] = useState(false);

  const closeModal = () => {
    setStateModal(false);
  };

  const openModal = () => {
    setStateModal(true);
  };

  useEffect(() => {
    dispatch(stepperAction.fetchStepper(activeMenu));
  }, [activeMenu, isOpenedModal]);

  
  return (
    <div>
      <Wrapper>
        <section className="row1">
          <Card>
            <CardTitlePrimary title={properties.pasos.paso1.verificacion.titulo} />
            <CardContent>
              <form>
                <div className="input-rut">
                  <Input
                    id="socioRut"
                    assistText={mensajeInputRut}
                    label="Tu RUT"
                    value={valueInputRut}
                    maxLength="12"
                    placeholder="Ej: 19.222.333-2"
                    variant="text"
                    onChange={(e) => obtenerRutInput(e)}
                  />
                </div>

                <div className="content-input">
                  <div className="modal">
                    <p className="documentotext">N° de Serie o documento</p>
                    <button type="button" onClick={openModal}>
                      <img src={iconMensajeInfo} alt="usuario TC" />
                    </button>
                  </div>
                  <div className="input-serie">
                    <Input
                      id="numeroDeSerie"
                      assistText={mensajeInputSerie}
                      value={valueNdeSerie}
                      maxLength="11"
                      placeholder="Ej: 111222333"
                      variant="text"
                      onChange={(e) => obtenerNumeroSerieInput(e)}
                    />
                  </div>
                </div>
              </form>
            </CardContent>
            <CardFooter>
              <div className="footer-content">
                <div>
                  <p>{properties.pasos.paso1.verificacion.autorizo}</p>
                </div>
                <div>
                  <Checkbox
                    checkboxValue={setAutorizo}
                    checkboxName={properties.pasos.paso1.verificacion.chechbox}
                    checkboxId="autorizacionCheckbox"
                    checkboxStatus={setAutorizo}
                    onChange={(e) => autorizoFunction(e.target.value)}
                  />
                </div>
              </div>
            </CardFooter>
          </Card>
        </section>
      </Wrapper>
      {isOpenedModal && <Modal closeModal={closeModal} />}
    </div>
  );
};

VerificacionTemplate.propTypes = {
  activeMenu: PropTypes.number,
  autorizoFunction: PropTypes.func,
  setAutorizo: PropTypes.bool,
  obtenerRutInput: PropTypes.func,
  obtenerNumeroSerieInput: PropTypes.func,
  valueInputRut: PropTypes.string,
  valueNdeSerie: PropTypes.string,
  mensajeInputRut: PropTypes.arrayOf(PropTypes.object),
  mensajeInputSerie: PropTypes.arrayOf(PropTypes.object),
};
VerificacionTemplate.defaultProps = {
  activeMenu: '',
  autorizoFunction: () => {},
  setAutorizo: '',
  obtenerRutInput: () => {},
  obtenerNumeroSerieInput: () => {},
  valueInputRut: '',
  valueNdeSerie: '',
  mensajeInputRut: '',
  mensajeInputSerie: {},
};

export default VerificacionTemplate;
